<template>
  <main class="page">
      <Popup v-if="showPopup" :content="content" />

      <section class="page__intro">
        <h1 class="page__title">Sätt upp dina personliga mål</h1>
        <p>Naturligtvis ökar motivationen om man sätter upp konkreta mål. Ta kontroll över ditt pensionssparande med hjälp av vår målsättningsgenerator.</p>
      </section>

      <div class="page__main">
        <TargetForm/>
      </div>
  </main>
</template>

<script>
import TargetForm from '../components/target/TargetForm.vue'
import Popup from '../components/elements/Popup.vue'

export default {
  name: 'Target',
  components: { TargetForm, Popup },
  data () {
    return {
      showPopup: true,
      content: {
        title: 'Hej ' + this.$store.getters.user.firstName,
        text: 'Du behöver fylla i din månadslön för att kunna bestämma din målbild.',
        link_msg: 'Mina tillgångar',
        link: '/assets'
      },
    }
  },
  async mounted() {
    if(this.$store.getters.user.access.income.monthlySalary !== '') {
      this.showPopup = false
    }
  }
}
</script>